import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { registrationsAPI } from '@/services/registrationsApi';
import { queryKeys } from './queryKeys';

export function useRegistrations() {
  return useQuery({
    queryKey: queryKeys.registrations.all(),
    queryFn: () => registrationsAPI.getRegistrations(),
  });
}

export function useRaceRegistrations(raceId?: any) {
  return useQuery({
    queryKey: queryKeys.registrations.byRace(raceId),
    queryFn: () => registrationsAPI.getRaceRegistrations(raceId),
    enabled: !!raceId,
  });
}

export function useCreateRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => registrationsAPI.createRegistration(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useCmsCreateRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => registrationsAPI.cmsCreateRegistration(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useUpdateRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => registrationsAPI.updateRegistration(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useDeleteRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => registrationsAPI.deleteRegistration(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useConfirmRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, paymentStatus }: any) =>
      registrationsAPI.confirmRegistration(id, paymentStatus),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useUpdateRegistrationBibNumber() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, bibNumber }: any) => registrationsAPI.updateBibNumber(id, bibNumber),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}

export function useMarkBibPickedUp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => registrationsAPI.markBibPickedUp(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.registrations._def }),
  });
}
